<template>
  <div>
    <div class="py-3 bg-primary mb-4"></div>
    <div v-if="loading" class="text-center">
      <b-spinner label="Loading" variant="primary" />
    </div>
    <div v-else class="row justify-content-center">
      <div class="col-4">
        <b-card>
          <template v-if="errorCode">
            <h1 class="text-center text-danger mb-2">
              <feather-icon
                class="text-danger"
                icon="AlertTriangleIcon"
                size="26"
              />
              Error
            </h1>
            <h3 class="mb-0 text-center">{{ errorCode }}</h3>
          </template>
          <template v-else>
            <h1 class="text-center text-primary mb-2">Código de usuario</h1>
            <h2 class="text-center mb-0">{{ dmpUserCode }}</h2>
          </template>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import router from "@/router";
import axios from "@axios";

export default {
  setup () {
    //HOOKS
    onMounted(async () => await getUserDmpCode());

    //DATA
    const dmpUserCode = ref(null);

    const errorCode = ref(null);

    const loading = ref(false);

    //METHODS
    const getUserDmpCode = async () => {
      const { token = null } = router.history.current.params;

      loading.value = true

      await axios.post('v1/dmp/capabilities/code-user-decrypt', { code: token })
        .then(response => {
          const { data } = response;

          dmpUserCode.value = data.data;
          hasError.value = false;
          error.value    = null
        })
        .catch((error) => {
          const { message = 'Error al obtener el código' } = error.response.data;

          errorCode.value = message;
          dmpUserCode.value = false;
        })
        .finally(() => {
          loading.value = false;
        });
    }

    return {
      dmpUserCode,
      errorCode,
      loading

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
